import * as React from 'react';
import { makeStyles } from '@material-ui/core';
// import { createPortal } from 'react-dom';

const useStyles = makeStyles({
    attribution: {
        color: '#000',
        // fontSize: 14,
        width: '100%',
        // height: 24,
        textAlign: 'right',
        position: 'relative',
        marginBottom: 8,

        '& span': {
            backgroundColor: 'white',
            padding: 4
        },
        '& a': {
            color: '#000',
            textDecoration: 'none'
        },
        '& img': {
            position: 'relative',
            top: 5
            // bottom: 2
        },
        'body.with-map &': {
            // opacity: 0
            display: 'none'
        }
    }
}, {name: 'indeed'});

function IndeedAttribution() {
    const classes = useStyles();

    // Indeed say to add this to the head, but it should work here...
    // <script type="text/javascript" src="//gdc.indeed.com/ads/apiresults.js" />
    return (
        <div className={classes.attribution}><span><a href="http://www.indeed.com">Jobs</a> by
            <a href="http://www.indeed.com">
                <img src="//www.indeed.com/p/jobsearch.gif" alt="Indeed"/>
            </a>
            </span>

        </div>
    );
}

// export function IndeedClickTracker() {
//     return createPortal(<script type="text/javascript" src="https://gdc.indeed.com/ads/apiresults.js" />, document.body);
// }

export default IndeedAttribution;
